import React from 'react';
import { Colors, FontSize } from '@common/tokens';

type Props = {
  children: React.ReactNode;
};

export const PostMessageEmpty = ({ children }: Props) => (
  <>
    <div className="wk-post-no-messages">
      <span>{children}</span>
    </div>
    <style jsx>{`
      .wk-post-no-messages span {
        padding: 16px;
        font-size: ${FontSize.md};
        border-radius: 12px;
        margin-bottom: 2px;
        display: inline-block;
        background-color: ${Colors.steelLightest};
      }
    `}</style>
  </>
);
